// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"fa27afbe374fe866fec5","339":"665ba96456adcb7418c9"}[chunkId] + ".js";
};